/** Source dictionary: every other locale must provide exactly these keys. */
export const en = {
  'app.title': 'Online booking',
  'app.offline': 'You are offline. Showing saved data.',
  'app.update': 'A new version is available.',
  'app.reload': 'Reload',
  'nav.book': 'Book',
  'nav.my': 'My bookings',
  'nav.language': 'Language',
  'footer.imprint': 'Imprint',
  'footer.privacy': 'Privacy',

  'home.title': 'Barbershops',
  'home.subtitle': 'Choose a shop to book an appointment.',
  'home.empty': 'No shops configured yet.',

  'book.service': 'Service',
  'book.barber': 'Barber',
  'book.anyBarber': 'Any barber',
  'book.anyBarberHint': 'Earliest free time',
  'book.date': 'Date',
  'book.time': 'Time',
  'book.noSlots': 'No free times on this day. Please pick another day.',
  'book.closed': 'Closed',
  'book.yourDetails': 'Your details',
  'book.name': 'Name',
  'book.phone': 'Phone',
  'book.email': 'Email (optional, for confirmation and reminder)',
  'book.consent': 'We only use your details for this appointment.',
  'book.privacyLink': 'Privacy notice',
  'book.remember': 'Remember my details on this device',
  'book.confirm': 'Book now',
  'book.booking': 'Booking…',
  'book.summary': '{service} with {barber}',
  'book.successTitle': 'Booked!',
  'book.successText': 'See you on {date}.',
  'book.addCalendar': 'Add to calendar',
  'book.another': 'Book another appointment',
  'book.cancelHint': 'Free cancellation up to {hours} h before the appointment.',

  'my.title': 'My bookings',
  'my.empty': 'No bookings on this device yet.',
  'my.upcoming': 'Upcoming',
  'my.past': 'Past',
  'my.cancel': 'Cancel',
  'my.cancelConfirm': 'Really cancel this appointment?',
  'my.cancelled': 'Appointment cancelled.',
  'my.tooLate': 'Cancellation only possible up to {hours} h before. Please call us.',

  'status.pending': 'Pending',
  'status.confirmed': 'Confirmed',
  'status.completed': 'Completed',
  'status.cancelled': 'Cancelled',
  'status.no_show': 'No-show',

  'error.generic': 'Something went wrong. Please try again.',
  'error.network': 'No connection. Please check your internet.',
  'error.notFound': 'Page not found.',
  'error.tenantNotFound': 'This shop does not exist.',
  'error.slotTaken': 'Sorry, this time was just booked. Please choose another.',
  'error.rateLimited': 'Too many bookings in a short time. Please try again later.',
  'error.outsideWindow': 'This time can no longer be booked.',
  'error.invalid': 'The input could not be saved. Please check it.',
  'error.unauthorized': 'Your session has expired. Please sign in again.',
  'error.invalidLogin': 'Email or password is incorrect.',
  'error.name_short': 'Please enter your name.',
  'error.name_long': 'Name is too long.',
  'error.phone_invalid': 'Please enter a valid phone number, e.g. 0151 2345678.',
  'error.email_invalid': 'Please enter a valid email address.',
  'error.back': 'Back to start',

  'hero.kicker': 'Barbershop · {city}',
  'hero.book': 'Book appointment',
  'hero.call': 'Call',
  'hero.openNow': 'Open now · until {time}',
  'hero.opensToday': 'Closed · opens today at {time}',
  'hero.opensTomorrow': 'Closed · opens tomorrow at {time}',
  'hero.opensOn': 'Closed · opens {day} at {time}',
  'info.address': 'Address',
  'info.route': 'Directions',
  'info.hours': 'Opening hours',
  'info.contact': 'Contact',
  'info.today': 'Today',
  'step.service': 'Choose a service',
  'step.barber': 'Who should cut?',
  'step.date': 'Pick a day',
  'step.time': 'Pick a time',
  'step.details': 'Your details',
  'slots.morning': 'Morning',
  'slots.afternoon': 'Afternoon',
  'slots.evening': 'Evening',
  'book.ticket': 'Your appointment',
  'home.heroTitle': 'Your barber. Booked online.',
  'home.heroText': 'Choose your shop, service and time – done in under a minute.',
  'home.book': 'Book',
} as const;

export type MessageKey = keyof typeof en;
export type Dictionary = Record<MessageKey, string>;
